import { useEffect } from 'react';

import { observer } from 'mobx-react';
import { getService } from 'react-in-angularjs';

import { angularizeWithProviders } from '../../../shared/providers';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import { chatStore } from '../../../shared/stores/chatStore';

const NgzChatInit = observer(() => {
  const AuthService = getService('AuthService');
  const { loggedInUser } = loggedInUserDataStore;
  const { solutionTypeFlags } = solutionsStore;

  const shouldInitChat =
    !!loggedInUser?.id &&
    solutionTypeFlags.NUTRITION &&
    !AuthService.getSelfBillingPaymentIssue(loggedInUser);

  useEffect(() => {
    if (shouldInitChat && !chatStore.chatClient) {
      chatStore.initializeChat();
    }

    return chatStore.resetChat;
  }, [shouldInitChat]);

  return null;
});

angularizeWithProviders(NgzChatInit, 'ngzChatInit', {});

export { NgzChatInit };
